import {
  getActiveWorksheetId,
  getActiveWorksheetName,
  getCellValue,
  getSelectedCell as getSelectedCellFromInstance,
  getWorksheetInstance,
} from "@/jspreadsheet/jspreadsheet";
import { CellValue } from "jspreadsheet-ce";

export const getWorksheetId = async (): Promise<string> => {
  return getActiveWorksheetId() || "";
};

export const getSheetName = (worksheetIdOrName?: string): string | null => {
  if (worksheetIdOrName) {
    return worksheetIdOrName;
  }
  return getActiveWorksheetName();
};

export const getSelectedCell = (): {
  address: string;
  value: CellValue | null;
} => {
  const selectedCell = getSelectedCellFromInstance();
  if (selectedCell) {
    return selectedCell;
  }

  const worksheet = getWorksheetInstance();
  if (worksheet) {
    const cell = getSelectedCellFromInstance();
    if (cell) {
      return cell;
    }
  }

  throw new Error("No cell selected");
};

export const getCellValueFromActiveWorksheet = (
  address: string,
): CellValue | null => {
  const worksheet = getWorksheetInstance();
  if (!worksheet) {
    throw new Error("Spreadsheet instance not available");
  }

  return getCellValue(address);
};
